var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.123,
    height: 11.729,
    viewBox: "0 0 9.123 11.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_delete_24px",
    d: "M5.652,13.426a1.307,1.307,0,0,0,1.3,1.3h5.213a1.307,1.307,0,0,0,1.3-1.3V5.606H5.652Zm8.471-9.774H11.842L11.19,3H7.932l-.652.652H5v1.3h9.123Z",
    transform: "translate(-5 -3)",
    fill: "#a6acb5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGrayIcon);
export default __webpack_public_path__ + "static/media/trash-gray-icon.4d11c86a929f4fcc1bdbade984654694.svg";
export { ForwardRef as ReactComponent };